import { buildRpaDomainSeoBundle } from "../rpaSeoUtils";

export const HOSPITALITY_DOMAIN_INTRO = {
  title: "Hospitality & Travel",
  content: "Document AI + RPA and workflow automation across Hotels. Each use case includes challenge and solution detail, process diagrams, and human-in-the-loop review for enterprises in India, UAE, KSA, UK, and USA.",
  seoDescription: "Hospitality & Travel automation use cases — document AI + RPA and workflow automation across Hotels. Validation, approvals, system updates, and exception handling.",
};

const slugify = (label) =>
  label.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');

function withMeta(uc) {
  return {
    ...uc,
    groupId: slugify(uc.subIndustry),
    seoTitle: uc.title,
    title: uc.shortTitle || uc.title,
    systems: uc.systems || SYSTEMS,
  };
}

const SYSTEMS = "PMS, CRS, CRM, Channel Manager, Email, Power BI";

const RAW = [
  {
    id: "guest-check-in-document-capture",
    subIndustry: "Hotels",
    department: "Front Office",
    businessProcess: "Guest check-in document capture",
    regions: "India, UAE/Dubai, KSA/Saudi Arabia, UK, USA",
    shortTitle: "Guest check-in document capture",
    title: "Guest Check-In Document Capture Automation for Hospitality & Travel",
    seoKeywords: "hospitality & travel, guest check-in document capture, AI automation, RPA, agentic AI, document AI",
    challenge: "Front office teams manually capture IDs, forms, signatures and preferences at check-in.",
    solution: "Implement Document AI + RPA to capture inputs, validate rules, route exceptions, generate summaries or actions, and update the target systems with human approval where required.",
    automationType: "Document AI + RPA",
    buyerPersona: "Front Office Manager",
    systems: "PMS, DMS, CRM, Payment Gateway",
    agentsRequired: "Document Extraction Agent, Guest Validation Agent, Exception Agent",
    inputData: "Forms, PDFs, emails, scanned documents, attachments, master data and guest check-in document capture rules",
    outputActions: "Extracted structured data, validation results, exception list and approval-ready guest check-in document capture record",
    keyBenefits: "Faster Turnaround, Lower Manual Effort, Improved Accuracy And Better Operational Visibility",
    roiTimeline: "3-6 months",
    implementationComplexity: "Medium",
    businessImpact: "High",
  },
  {
    id: "vendor-invoice-processing",
    subIndustry: "Hotels",
    department: "Procurement",
    businessProcess: "Vendor invoice processing",
    regions: "India, UAE/Dubai, KSA/Saudi Arabia, UK, USA",
    shortTitle: "Vendor invoice processing",
    title: "Vendor Invoice Processing Automation for Hospitality & Travel",
    seoKeywords: "hospitality & travel, vendor invoice processing, AI automation, RPA, agentic AI, document AI",
    challenge: "Supplier invoices are manually matched with POs, GRNs and approvals.",
    solution: "Implement Document AI + RPA to capture inputs, validate rules, route exceptions, generate summaries or actions, and update the target systems with human approval where required.",
    automationType: "Document AI + RPA",
    buyerPersona: "Procurement Head, CFO",
    systems: "ERP, Procurement System, Email, Vendor Portal",
    agentsRequired: "Document Extraction Agent, Vendor Validation Agent, Exception Agent",
    inputData: "Forms, PDFs, emails, scanned documents, attachments, master data and vendor invoice processing rules",
    outputActions: "Extracted structured data, validation results, exception list and approval-ready vendor invoice processing record",
    keyBenefits: "Faster Turnaround, Lower Manual Effort, Improved Accuracy And Better Operational Visibility",
    roiTimeline: "3-6 months",
    implementationComplexity: "Medium",
    businessImpact: "High",
  },
];
export const HOSPITALITY_USE_CASES = RAW.map(withMeta);
const GROUP_ORDER = ["Hotels"];
export const HOSPITALITY_GROUPS = GROUP_ORDER.map((label) => ({
  id: slugify(label),
  label,
})).filter((g) => HOSPITALITY_USE_CASES.some((uc) => uc.groupId === g.id));
const seo = buildRpaDomainSeoBundle({
  domainSlug: 'hospitality-travel-domain',
  domainIntro: HOSPITALITY_DOMAIN_INTRO,
  useCases: HOSPITALITY_USE_CASES,
});
export const HOSPITALITY_USE_CASES_SEO = seo.useCasesSeo;
export const HOSPITALITY_DOMAIN_FAQS = seo.domainFaqs;
export const HOSPITALITY_ITEM_LIST_JSONLD = seo.itemListJsonLd;
export const HOSPITALITY_FAQ_JSONLD = seo.faqJsonLd;
export const HOSPITALITY_BREADCRUMB_JSONLD = seo.breadcrumbJsonLd;
export const HOSPITALITY_WEBPAGE_JSONLD = seo.webPageJsonLd;

